import { useState } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Open WhatsApp with the form details
    const whatsappNumber = props.data && props.data.whatsapp ? props.data.whatsapp : "94772920945";
    const text = `Name: ${name}\nEmail: ${email}\nMessage: ${message}`;
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
    clearState();
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Have a printing project in mind? Fill out the form below and we will
                  get back to you with a quote as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-logo-wrap">
              <img src="img/Logo.png" alt="ADL Digi House (Pvt) Ltd Logo" className="footer-logo-img" />
            </div>
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Telephone
                </span>{" "}
                {props.data
                  ? props.data.tele
                    ? props.data.tele.join(" / ")
                    : props.data.phone
                    ? props.data.phone
                    : "loading"
                  : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-fax"></i> Fax
                </span>{" "}
                {props.data && props.data.fax ? props.data.fax : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data
                  ? props.data.emails
                    ? props.data.emails.join(" ")
                    : props.data.email
                    ? props.data.email
                    : "loading"
                  : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-clock-o"></i> Working Hours
                </span>{" "}
                {props.data && props.data.hours
                  ? `Weekdays: ${props.data.hours.weekdays} | Saturday: ${props.data.hours.saturday} | Sunday: ${props.data.hours.sunday}`
                  : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 ADL Digi House (Pvt) Ltd. All Rights Reserved.
          </p>
          <p style={{marginTop: "10px", fontSize: "14px"}}>
            {props.data ? props.data.address : "No 25, 1st Floor, YMBA Complex, Borella, Colombo 08, Sri Lanka"} | Tel: {props.data
              ? props.data.tele
                ? props.data.tele.join(" / ")
                : props.data.phone
                ? props.data.phone
                : "011 268 7456"
              : "011 268 7456"}{props.data && props.data.fax ? ` | Fax: ${props.data.fax}` : ""}
          </p>
        </div>
      </div>
    </div>
  );
};
